import './main.berakningsmoduler.scss'

import $ from 'jquery'
window.$ = $
window.jQuery = $

import 'foundation-sites'
import '@mcfse/design-system'

import { initSite } from '@js/site.js'

document.addEventListener('DOMContentLoaded', () => {
    initSite()
})